import angular from "angular";

angular
    .module('app')
    .component('lessonChapterForm', {
        template: require('./lesson-chapter-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.chapter = null;

    $ctrl.$onInit = function () {
        $ctrl.chapters = $ctrl.resolve.chapters;
        $ctrl.lesson = $ctrl.resolve.lesson;
        $ctrl.chapter = $ctrl.resolve.chapter;
    };

    $ctrl.submit = function () {
        $ctrl.loading = true;
        $http.post(`/admin/lessons/${$ctrl.lesson.id}/change-chapter`, {chapter_id: $ctrl.chapter.id}).then(
            function (response) {

                $ctrl.loading = false;
                Notifier.success('Успешно обновлен', 2);
                 $ctrl.close({$value: $ctrl.chapter});

            },
            function (error) {
                $ctrl.loading = false;
                Notifier.success('Успешно обновлен', 3);
            }
        )
    };
}